import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthToken, UserBrief } from "../types/api";

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  accessTokenExpiresAt: string | null;
  user: UserBrief | null;
  hydrated: boolean;
  setSession: (session: AuthToken) => void;
  clearSession: () => void;
  updateUser: (patch: Partial<UserBrief>) => void;
  setHydrated: (value: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      accessTokenExpiresAt: null,
      user: null,
      hydrated: false,
      setSession: (session) =>
        set({
          accessToken: session.accessToken,
          refreshToken: session.refreshToken,
          accessTokenExpiresAt: session.accessTokenExpiresAt,
          user: session.user,
        }),
      clearSession: () =>
        set({ accessToken: null, refreshToken: null, accessTokenExpiresAt: null, user: null }),
      updateUser: (patch) => set((state) => ({ user: state.user ? { ...state.user, ...patch } : null })),
      setHydrated: (value) => set({ hydrated: value }),
    }),
    {
      name: "lia-admin-auth",
      partialize: ({ accessToken, refreshToken, accessTokenExpiresAt, user }) => ({
        accessToken,
        refreshToken,
        accessTokenExpiresAt,
        user,
      }),
      onRehydrateStorage: () => (state) => state?.setHydrated(true),
    },
  ),
);
